import { Helmet } from 'react-helmet-async';

interface SeoProps { title?: string; description?: string; path?: string }
const BASE = 'https://sustainalyze.app';
const DEFAULT_TITLE = 'Sustainalyze — TSRS & CBAM uyumlu ESG raporlama';
const DEFAULT_DESC = 'Türk ihracatçılar için TSRS ve CBAM uyumlu karbon, su ve ESG raporlama — denetime hazır.';

export function Seo({ title, description, path }: SeoProps) {
  const fullTitle = title ? `${title} — Sustainalyze` : DEFAULT_TITLE;
  const desc = description ?? DEFAULT_DESC;
  const url = path ? `${BASE}${path}` : BASE;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
